export default __webpack_public_path__ + "static/PremiumServiceBrands-fe11b9cbe558e823e0e554f23c85959b.png";